import { render, staticRenderFns } from "./PortfolioSelect.vue?vue&type=template&id=2a377336&scoped=true&"
import script from "./PortfolioSelect.vue?vue&type=script&lang=js&"
export * from "./PortfolioSelect.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioSelect.vue?vue&type=style&index=0&id=2a377336&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a377336",
  null
  
)

export default component.exports